import i18n from '~/i18n';

const getDefaultConfig = () => ({
  typeOfDocument: {
    title: '',
  },
  invoiceItems: {
    title: i18n.t('form.invoiceForm.headers.items'),
    quantity: {
      label: i18n.t('form.invoiceForm.fields.items.quantity'),
      visible: true,
    },
    unit: {
      label: i18n.t('form.invoiceForm.fields.items.unit_type'),
      visible: true,
    },
    description: {
      label: i18n.t('form.invoiceForm.fields.items.description'),
      visible: true,
    },
    price: {
      label: i18n.t('form.invoiceForm.fields.items.price'),
      visible: true,
    },
    amount: {
      label: i18n.t('form.invoiceForm.fields.items.total'),
      visible: true,
    },
    tax: {
      label: i18n.t('form.invoiceForm.fields.items.vat_rate'),
      visible: true,
    },
  },
  summary: {
    subtotal: {
      visible: true,
    },
    items: {
      visible: true,
    },
  },
  vatCalculation: {
    visible: true,
  },
});

const getConfigWithoutTax = () => ({
  ...getDefaultConfig(),
  invoiceItems: {
    ...getDefaultConfig().invoiceItems,
    tax: {
      visible: false,
    },
  },
  vatCalculation: {
    visible: false,
  },
  summary: {
    ...getDefaultConfig().summary,
    items: {
      visible: false,
    },
  },
});

const formConfigs = {
  default: () => ({ ...getDefaultConfig() }),
  vatInvoice: () => ({ ...getDefaultConfig() }),
  invoice: () => ({ ...getConfigWithoutTax() }),
  advance: () => ({ ...getDefaultConfig() }),
  proforma: () => ({ ...getConfigWithoutTax() }),
  vatCreditNote: () => ({ ...getDefaultConfig() }),
  vatDutyReversed: () => ({ ...getDefaultConfig() }),
};

export default formConfigs;
